import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Simple landing page component to show when not authenticated
const LandingPage = () => {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      padding: '20px',
      textAlign: 'center',
      backgroundColor: '#f5f5f5'
    }}>
      <h1 style={{ marginBottom: '20px', color: '#333' }}>
        Hair & Beauty Pricing Calculator
      </h1>
      <p style={{ marginBottom: '30px', color: '#666', maxWidth: '500px' }}>
        Please log in through your SalonLogic dashboard to access the pricing calculator.
      </p>
      <a 
        href="https://app.salonlogicpro.co.uk" 
        style={{
          padding: '12px 24px',
          backgroundColor: '#007cba',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '4px',
          fontSize: '16px'
        }}
      >
        Go to Dashboard
      </a>
      <div style={{ marginTop: '20px', fontSize: '12px', color: '#999' }}>
        <p>Debug Info:</p>
        <p>Token: {localStorage.getItem('token') ? 'Present (' + localStorage.getItem('token').substring(0, 20) + '...)' : 'None'}</p>
        <p>User: {localStorage.getItem('user') ? 'Present' : 'None'}</p>
        <p>Auth State: {localStorage.getItem('isAuthenticated') || 'false'}</p>
      </div>
    </div>
  );
};

const ProtectedRoute = ({ children, adminRequired = false, requireSubscription = false }) => {
  const { isAuthenticated, loading, user, tokenChecked } = useAuth();
  
  console.log('ProtectedRoute check:', { 
    isAuthenticated, 
    loading,
    tokenChecked,
    hasUser: !!user,
    adminRequired,
    requireSubscription,
    pathname: window.location.pathname,
    token: localStorage.getItem('token')?.substring(0, 30) + '...',
    userFromStorage: !!localStorage.getItem('user')
  });
  
  // CRITICAL: Wait for auth initialization to complete
  if (loading || !tokenChecked) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }
  
  // Get auth data from localStorage
  const token = localStorage.getItem('token');
  const userData = localStorage.getItem('user');
  const isAuthenticatedFlag = localStorage.getItem('isAuthenticated');
  
  // Check for WordPress SSO authentication
  const isWordPressSSOAuthenticated = (
    (token === 'wordpress-sso' || token === 'sso-authenticated' || token === 'dashboard-sso') && 
    userData &&
    isAuthenticatedFlag === 'true'
  );
  
  // Check for JWT token authentication (native login)
  const isJWTAuthenticated = (
    token && 
    token.includes('.') &&
    token.split('.').length === 3 &&
    userData
  );
  
  // Check for regular authentication via React state
  const isRegularAuthenticated = isAuthenticated && user;
  
  // Allow access if any authentication method is valid
  if (isWordPressSSOAuthenticated || isRegularAuthenticated || isJWTAuthenticated) {
    console.log('ProtectedRoute: Authentication valid', {
      wordpressSSOAuth: isWordPressSSOAuthenticated,
      regularAuth: isRegularAuthenticated,
      jwtAuth: isJWTAuthenticated
    });
    
    if (adminRequired) {
      let userRole = null;
      if (user && user.role) {
        userRole = user.role;
      } else if (userData) {
        try {
          const parsedUser = JSON.parse(userData);
          userRole = parsedUser.role;
        } catch (e) {
          console.error('Error parsing user data:', e);
        }
      }
      if (userRole !== 'admin') {
        console.log('ProtectedRoute: Admin required but user role is:', userRole);
        return <Navigate to="/dashboard" replace />;
      }
    }
    
    if (requireSubscription) {
      let hasSubscription = false;
      if (user && user.subscription) {
        hasSubscription = user.subscription.active;
      } else if (userData) {
        try {
          const parsedUser = JSON.parse(userData);
          hasSubscription = parsedUser.subscription?.active || parsedUser.subscription_active;
        } catch (e) {
          console.error('Error parsing user data for subscription check:', e);
        }
      }
      if (!hasSubscription) {
        console.log('ProtectedRoute: Subscription required but not active');
        return <Navigate to="/subscribe" replace />;
      }
    }
    
    console.log('ProtectedRoute: Access granted');
    return children;
  }
  
  console.log('ProtectedRoute: Not authenticated, showing landing page');
  return <LandingPage />;
};

export default ProtectedRoute;
